import styled from "styled-components"
import { darken } from "polished"

export const Container = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 0.1rem;
  width: 100%;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.darkGrey};
  border: 1px solid #ececec;
`

export const List = styled.ul`
  padding: 0;
  margin: 0;
`

export const ListItem = styled.li`
  list-style: none;
  font-weight: 500;
  padding: 2px;
`
export const Link = styled.a`
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => props.theme.colors.content.text};

  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 1.5rem */

  &:hover {
    background: ${(props) => darken(0.04, props.theme.colors.lightGrey)};
  }
`

export const LinkText = styled.span`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
`
